<template>
<div>
	<div class="title">{{title}}</div>
	<Form :model="form" :label-width="150" class="mt15" :rules="formRules" ref="form">
		<FormItem label="公司名称" class="w600" prop="subjectName" v-if="type=='COMPANY'">
			<Input 
				v-model="form.subjectName" 
				placeholder="请输入营业执照上的公司名称"
				@on-blur="change"
				:maxlength="45">
			</Input>
		</FormItem>
		<FormItem label="统一社会信用代码" class="w600" prop="idNumber" v-if="type=='COMPANY'">
			<Input 
				v-model="form.idNumber" 
				placeholder="请输入营业执照上的统一社会信用代码" 
				@on-change="resetUpperCaseValue"
				@on-blur="change"
				:maxlength="18"></Input>
		</FormItem>
		<FormItem label="申请人姓名" class="w600" prop="subjectName" v-if="type=='PERSON'">
			<Input 
				v-model="form.subjectName" 
				placeholder="请输入申请人姓名（雇主）"
				@on-blur="change"
				:maxlength="45">
			</Input>
		</FormItem>
		<FormItem label="申请人身份证号码" class="w600" prop="idCard" v-if="type=='PERSON'">
			<Input 
				v-model="form.idCard" 
				placeholder="请输入申请人身份证号码" 
				:maxlength="40"></Input>
		</FormItem>
		<FormItem label="地区" prop="areaCode" class="w600">
			<Area v-model="form.areaCode" placeholder="请选择省市区"/>
		</FormItem>
		<FormItem label="通讯地址" class="w600" prop="address">
			<Input v-model="form.address" placeholder="请输入实际经营地址" @on-blur="change" :maxlength="150"></Input>
		</FormItem>
		<FormItem label="联系人" class="w600" prop="contactName">
			<Input v-model="form.contactName" placeholder="请输入联系人" :maxlength="20"></Input>
		</FormItem>
		<FormItem label="联系电话" class="w600" prop="contactPhone">
			<Input v-model="form.contactPhone" placeholder="请输入手机号" @on-blur="change" :maxlength="20"></Input>
		</FormItem>
		<FormItem label="联系人邮箱" class="w600" prop="contactEmail">
			<Input v-model="form.contactEmail" placeholder="请输入联系人邮箱" @on-blur="change" :maxlength="120"></Input>
		</FormItem>
	</Form>
	<Form :model="uploadForm" :label-width="150" :rules="uploadFormRules" ref="uploadForm">
		<FormItem label="资料上传" required>
			<p class="note" v-if="note">{{note}}</p>
			<FormItem prop="businessLicenseUrl" v-if="type=='COMPANY'" class="upload">
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val,'businessLicenseUrl')" 
					:accept="['image']">
					<div class="upload-img-main" v-if="!uploadForm.businessLicenseUrl">
						<Icon type="ios-camera" size="20"></Icon>
						<p>营业执照</p>
					</div>
					<img 
						:src="ossImg(uploadForm.businessLicenseUrl,'s')" 
						v-show="uploadForm.businessLicenseUrl" 
						width="100%" 
						style="display:block" />
				</UploadFileImg>
			</FormItem>
			<FormItem prop="front" v-if="type=='PERSON'" class="upload">
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val,'front')" 
					:accept="['image']">
					<div class="upload-img-main" v-if="!uploadForm.front">
						<Icon type="ios-camera" size="20"></Icon>
						<p>申请人<br>身份证正面</p>
					</div>
					<img 
						:src="ossImg(uploadForm.front,'s')" 
						v-show="uploadForm.front" 
						width="100%" 
						style="display:block" />
				</UploadFileImg>
			</FormItem>
			<FormItem prop="back" v-if="type=='PERSON'" class="upload">
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val,'back')" 
					:accept="['image']">
					<div class="upload-img-main" v-if="!uploadForm.back">
						<Icon type="ios-camera" size="20"></Icon>
						<p>申请人<br>身份证反面</p>
					</div>
					<img 
						:src="ossImg(uploadForm.back,'s')" 
						v-show="uploadForm.back" 
						width="100%" 
						style="display:block" />
				</UploadFileImg>
			</FormItem>
			<FormItem :prop="item.key" v-for="(item, index) in uploadFileList" :key="index" class="upload">
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val,item.key)"
					:accept="item.accept"
					style="width:150px">
					<div class="upload-img-main" v-if="!item.type||item.type=='file'">
						<Icon type="ios-cloud-upload-outline" size="20" v-if="!uploadForm[item.key]"/>
						<a :href="uploadForm[item.key]" v-if="uploadForm[item.key]" target="_blank" @click.stop>查看</a>
						<p v-html="item.label"></p>
					</div>
					<template v-if="item.type=='image'">
						<div class="upload-img-main" v-if="!uploadForm[item.key]">
							<Icon type="ios-camera" size="20"></Icon>
							<p>申请人<br>身份证反面</p>
						</div>
						<img 
							:src="ossImg(uploadForm[item.key],'s')" 
							v-show="uploadForm[item.key]" 
							width="100%" 
							style="display:block" />
					</template>
				</UploadFileImg>
			</FormItem>
		</FormItem>
		
	</Form>
</div>
</template>
<script>
import Area from '@/pages/haierProduct/components/common/Area'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ Area,UploadFileImg },
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		title:{
			type:String,
			default:'申请人信息'
		},
		type:{
			type:String,
			default:'COMPANY' // 企业COMPANY，个人PERSON
		},
		uploadFileList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	data () {
		return {
			form:{},
			formRules:{
				subjectName:[{required:true,message:this.type=='COMPANY'?'公司名称必填':'申请人姓名必填',trigger:'blur'}],
				idNumber:[{required:true,message:'统一社会信用代码必填',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.organizationCode}],
				idCard:[{required:true,message:'身份证号必填',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.idcard}],
				address:[{required:true,message:'实际经营地址必填（最少6位）',min:6,trigger:'blur'}],
				contactName:[{required:true,message:'联系人姓名必填',trigger:'blur'},{message:'请输入正确的姓名',trigger:'blur',pattern:this.rules.chinaName}],
				contactPhone:[{required:true,message:'请填写正确的手机号',trigger:'blur',pattern:this.rules.tel}],
				contactEmail:[{required:true,message:'联系人邮箱必填',trigger:'change'},{message:'格式错误',trigger:'blur',pattern:this.rules.email}],
				contactsCertificateNumber:[{required:true,message:'联系人证件号必填',trigger:'change'}],
				areaCode:[{required:true,message:'请选择地区',trigger:'change'}],
			},
			uploadForm:{},
			uploadFormRules:{
				businessLicenseUrl:[{required:true,message:'请上传营业执照',trigger:'change'}],
				front:[{required:true,message:'请上传身份证正面',trigger:'change'}],
				back:[{required:true,message:'请上传身份证反面',trigger:'change'}],
			}
		}
	},
	computed:{
		note(){
			let note=this.uploadFileList.map(item=>{
				return item.note||''
			})
			return note.toString()
		}
	},
	watch:{
		info: {
			handler(res) {
				this.initData()
			},
			immediate:true
		},
		type(){
			this.$set(this.formRules,'subjectName',[{required:true,message:this.type=='COMPANY'?'公司名称必填':'申请人姓名必填',trigger:'blur'}])
		}
	},
	methods:{
		initData(){
			this.form=this.jsonCopy(this.info)
			if(this.info.annexUrls){
				let annexUrls=this.info.annexUrls.split(',');
				let baseIndex=0;
				if(this.type=='COMPANY'){
					!this.uploadForm.businessLicenseUrl&&this.$set(this.uploadForm,'businessLicenseUrl',annexUrls[0])
					baseIndex=1;
				}else{
					!this.uploadForm.front&&this.$set(this.uploadForm,'front',annexUrls[0])
					!this.uploadForm.back&&this.$set(this.uploadForm,'back',annexUrls[1])
					baseIndex=2;
				}
				this.uploadFileList.forEach((item,index)=>{
					if(!this.uploadForm[item.key]){
						this.$set(this.uploadForm,item.key,annexUrls[baseIndex+index])
					}
				})
			}
			this.uploadFileList.forEach(item=>{
				if(!this.uploadFormRules[item.key]){
					this.uploadFormRules[item.key]={required:true,message:'请上传'+item.name,trigger:'change'}
				}
			})
		},
		// 上传回调方法
		uploadSuccess(val,key){
			this.$set(this.uploadForm,key,val.url)
			this.$refs.uploadForm.validateField(key);
		},
		// 校验
		async sub () {
			let formValid=await this.$refs.form.validate();
			let uploadFormValid=await this.$refs.uploadForm.validate();
			if(formValid&&uploadFormValid){
				let annexUrls=this.type=='COMPANY'?[this.uploadForm.businessLicenseUrl]:[this.uploadForm.front,this.uploadForm.back]
				this.uploadFileList.forEach(item => {
					annexUrls.push(this.uploadForm[item.key])
				});
				return {
					...this.form,
					annexUrls:annexUrls.toString(),
					idNumber:this.type=='COMPANY'?this.form.idNumber:this.form.idCard
				}
			}else{
				this.toast(this.title+'校验失败','error');
				return false
			}
		},
		// 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
		change() {
			this.$emit('on-change',this.form)
		},
		// 小写转大写
		resetUpperCaseValue(event){
			if(event.target.value){
				this.form.idNumber=event.target.value.toUpperCase();
			}
		}
		
	},
}
</script>
<style scoped lang="less">
	.upload{
		width: 100px;
		display: inline-block;
		margin-right: 10px;
		margin-bottom: 10px;
		&-img-main{
			padding:10px 0;
		}
	}
	.note{
		color: #ff9900;
		font-size: 14px;
		line-height: 34px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/Applicant.vue